/* eslint-disable no-unused-vars */
import React, { useState } from "react";

const StudentData = () => {
  // ------------------------ DUMMY DATA ------------------------
  const studentInfo = {
    name: "NANDINI",
    roll: "2025193",
    testName: "WEEKLY TEST-12",
    date: "01-12-2025, 09:01 AM",
    college: "SARVAJNA AND JUSTICE SHIVARAJ PATIL COLLEGE GULBARGA",
    course: "1st PUC",
    section: "STAR 1"
  };

  const overallAnalysis = {
    score: 401,
    totalMarks: 720,
    correct: 102,
    wrong: 36,
    left: 32,
    accuracy: "76%",
    botany: 128,
    zoology: 102,
    physics: 52,
    chemistry: 119,
  };

  const subjectWiseAnalysis = [
    { subject: "Botany", total: 45, correct: 34, wrong: 8, left: 3, accuracy: "81%", color: "#4CAF50" },
    { subject: "Zoology", total: 45, correct: 28, wrong: 10, left: 7, accuracy: "74%", color: "#2196F3" },
    { subject: "Physics", total: 45, correct: 15, wrong: 8, left: 22, accuracy: "65%", color: "#FF9800" },
    { subject: "Chemistry", total: 45, correct: 32, wrong: 9, left: 4, accuracy: "78%", color: "#E91E63" },
  ];

  const leaderboard = [
    { rank: 1, name: "Nandini (You)", marks: 401, accuracy: "76%" },
    { rank: 2, name: "Mahesh", marks: 383, accuracy: "70%" },
    { rank: 3, name: "Vaishnavi", marks: 355, accuracy: "69%" },
    { rank: 4, name: "Sujan", marks: 338, accuracy: "69%" },
    { rank: 5, name: "Arpita", marks: 322, accuracy: "83%" }
  ];

  const chapterWise = [
    { chapter: "Work-energy-power", total: 25, correct: 14, wrong: 6, left: 5, accuracy: "70%" },
    { chapter: "Motion in plane", total: 12, correct: 1, wrong: 10, left: 1, accuracy: "33%" },
    { chapter: "Mechanical properties of fluids", total: 8, correct: 0, wrong: 0, left: 8, accuracy: "0%" },
  ];

  const conceptWise = [
    { concept: "Work Done By Variable Force", total: 4, correct: 1, wrong: 0, left: 3, accuracy: "100%" },
    { concept: "Kinetic Energy", total: 3, correct: 2, wrong: 1, left: 0, accuracy: "67%" },
    { concept: "Potential Energy", total: 10, correct: 6, wrong: 3, left: 1, accuracy: "67%" },
    { concept: "Work Energy Theorem by Constant Force", total: 8, correct: 2, wrong: 5, left: 1, accuracy: "71%" },
  ];

  const subjectAccuracy = [
    { name: "Physics", value: "65%", color: "#FF9800" },
    { name: "Chemistry", value: "78%", color: "#E91E63" },
    { name: "Botany", value: "81%", color: "#4CAF50" },
    { name: "Zoology", value: "74%", color: "#2196F3" }
  ];

  const comparison = {
    you: { score: 401, accuracy: "76%", correct: 102, wrong: 36, left: 32 },
    topper: { score: 401, accuracy: "76%", correct: 109, wrong: 35, left: 36 },
  };

  const [selectedSubject, setSelectedSubject] = useState("Physics");

  // ------------------------ STYLES ------------------------
  const styles = {
    container: {
      padding: "16px",
      backgroundColor: "#f8f9fa",
      minHeight: "100vh",
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
    },
    header: {
      backgroundColor: "#fff",
      borderRadius: "10px",
      padding: "20px",
      marginBottom: "20px",
      boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
      border: "1px solid #eaeaea"
    },
    card: {
      backgroundColor: "#fff",
      borderRadius: "10px",
      padding: "20px",
      marginBottom: "20px",
      boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
      border: "1px solid #eaeaea"
    },
    metricBox: {
      backgroundColor: "#f8f9fa",
      borderRadius: "8px",
      padding: "15px",
      textAlign: "center",
      border: "1px solid #e0e0e0"
    },
    badge: {
      backgroundColor: "#007bff",
      color: "white",
      padding: "4px 12px",
      borderRadius: "20px",
      fontSize: "0.85rem",
      fontWeight: "600"
    },
    table: {
      width: "100%",
      borderCollapse: "collapse"
    },
    tableHeader: {
      backgroundColor: "#f8f9fa",
      padding: "12px 16px",
      textAlign: "left",
      fontWeight: "600",
      color: "#495057",
      borderBottom: "2px solid #e9ecef"
    },
    tableCell: {
      padding: "12px 16px",
      borderBottom: "1px solid #e9ecef"
    },
    progressBar: {
      height: "6px",
      borderRadius: "3px",
      backgroundColor: "#e9ecef",
      overflow: "hidden"
    },
    progressFill: {
      height: "100%",
      borderRadius: "3px"
    }
  };

  return (
    <div style={styles.container}>
      {/* ================= HEADER ================= */}
      <div style={styles.header}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "15px" }}>
          <div>
            <h3 style={{ margin: "0 0 8px 0", color: "#2c3e50", fontWeight: "700" }}>
              {studentInfo.name} <span style={{ fontSize: "0.9em", color: "#6c757d" }}>({studentInfo.roll})</span>
            </h3>
            <div style={{ color: "#6c757d", fontSize: "0.95rem" }}>
              <div>{studentInfo.testName} • {studentInfo.date}</div>
              <div>{studentInfo.college}</div>
              <div>{studentInfo.course} • {studentInfo.section}</div>
            </div>
          </div>
          <button style={{
            backgroundColor: "#2c3e50",
            color: "white",
            border: "none",
            padding: "8px 20px",
            borderRadius: "6px",
            fontWeight: "600",
            cursor: "pointer"
          }}>
            ← Back
          </button>
        </div>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px", marginBottom: "20px" }}>
        {/* ================= OVERALL SCORE ================= */}
        <div style={styles.card}>
          <h4 style={{ margin: "0 0 20px 0", color: "#2c3e50", fontWeight: "600" }}>Overall Score</h4>
          <div style={{ textAlign: "center", marginBottom: "25px" }}>
            <div style={{ fontSize: "3.5rem", fontWeight: "800", color: "#007bff", lineHeight: "1" }}>
              {overallAnalysis.score}
              <span style={{ fontSize: "1.5rem", color: "#6c757d" }}>/{overallAnalysis.totalMarks}</span>
            </div>
            <div style={{ fontSize: "1.1rem", color: "#28a745", fontWeight: "600" }}>
              Accuracy: {overallAnalysis.accuracy}
            </div>
          </div>
          
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "15px" }}>
            <div style={styles.metricBox}>
              <div style={{ color: "#28a745", fontSize: "1.5rem", fontWeight: "700" }}>{overallAnalysis.correct}</div>
              <div style={{ color: "#6c757d", fontSize: "0.9rem" }}>Correct</div>
            </div>
            <div style={styles.metricBox}>
              <div style={{ color: "#dc3545", fontSize: "1.5rem", fontWeight: "700" }}>{overallAnalysis.wrong}</div>
              <div style={{ color: "#6c757d", fontSize: "0.9rem" }}>Wrong</div>
            </div>
            <div style={styles.metricBox}>
              <div style={{ color: "#ffc107", fontSize: "1.5rem", fontWeight: "700" }}>{overallAnalysis.left}</div>
              <div style={{ color: "#6c757d", fontSize: "0.9rem" }}>Left</div>
            </div>
            <div style={styles.metricBox}>
              <div style={{ fontSize: "1.5rem", fontWeight: "700" }}>{overallAnalysis.accuracy}</div>
              <div style={{ color: "#6c757d", fontSize: "0.9rem" }}>Accuracy</div>
            </div>
          </div>
        </div>

        {/* ================= SUBJECT BREAKDOWN ================= */}
        <div style={styles.card}>
          <h4 style={{ margin: "0 0 20px 0", color: "#2c3e50", fontWeight: "600" }}>Subject Breakdown</h4>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "15px" }}>
            {subjectWiseAnalysis.map((subject, index) => (
              <div key={index} style={{
                backgroundColor: `${subject.color}15`,
                borderRadius: "8px",
                padding: "15px",
                borderLeft: `4px solid ${subject.color}`
              }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "8px" }}>
                  <div style={{ fontWeight: "600", color: "#2c3e50" }}>{subject.subject}</div>
                  <div style={{ fontWeight: "700", color: subject.color }}>{subject.accuracy}</div>
                </div>
                <div style={{ fontSize: "0.85rem", color: "#6c757d", marginBottom: "5px" }}>
                  {subject.correct}/{subject.total} correct
                </div>
                <div style={styles.progressBar}>
                  <div style={{
                    ...styles.progressFill,
                    width: `${(subject.correct / subject.total) * 100}%`,
                    backgroundColor: subject.color
                  }}></div>
                </div>
                <div style={{ display: "flex", justifyContent: "space-between", fontSize: "0.8rem", marginTop: "5px" }}>
                  <span style={{ color: "#28a745" }}>✓ {subject.correct}</span>
                  <span style={{ color: "#dc3545" }}>✗ {subject.wrong}</span>
                  <span style={{ color: "#ffc107" }}>○ {subject.left}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ================= LEADERBOARD ================= */}
      <div style={styles.card}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
          <h4 style={{ margin: "0", color: "#2c3e50", fontWeight: "600" }}>Leaderboard</h4>
          <span style={{ color: "#6c757d", fontSize: "0.9rem" }}>Top 5 Students</span>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(5, 1fr)", gap: "15px" }}>
          {leaderboard.map((student, index) => (
            <div key={index} style={{
              backgroundColor: index === 0 ? "#e3f2fd" : "#f8f9fa",
              borderRadius: "8px",
              padding: "15px",
              border: index === 0 ? "2px solid #2196F3" : "1px solid #e0e0e0",
              textAlign: "center"
            }}>
              <div style={{ 
                display: "inline-block",
                width: "28px",
                height: "28px",
                lineHeight: "28px",
                borderRadius: "50%",
                backgroundColor: index === 0 ? "#2196F3" : index === 1 ? "#FF9800" : index === 2 ? "#4CAF50" : "#9E9E9E",
                color: "white",
                fontWeight: "700",
                fontSize: "0.9rem",
                marginBottom: "10px"
              }}>
                {student.rank}
              </div>
              <div style={{ fontWeight: "600", marginBottom: "5px" }}>{student.name}</div>
              <div style={{ fontSize: "1.5rem", fontWeight: "700", color: "#2c3e50" }}>{student.marks}</div>
              <div style={{ fontSize: "0.9rem", color: "#6c757d" }}>{student.accuracy} accuracy</div>
            </div>
          ))}
        </div>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "2fr 1fr", gap: "20px" }}>
        {/* ================= CHAPTER & CONCEPT ANALYSIS ================= */}
        <div>
          <div style={styles.card}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
              <h5 style={{ margin: "0", color: "#2c3e50", fontWeight: "600" }}>Chapter Analysis</h5>
              <select style={{
                padding: "6px 12px",
                borderRadius: "6px",
                border: "1px solid #ced4da",
                backgroundColor: "white",
                fontSize: "0.9rem"
              }}>
                <option>Physics</option>
                <option>Chemistry</option>
                <option>Botany</option>
                <option>Zoology</option>
              </select>
            </div>
            <table style={styles.table}>
              <thead>
                <tr>
                  <th style={styles.tableHeader}>Chapter</th>
                  <th style={styles.tableHeader}>Total</th>
                  <th style={styles.tableHeader}>Accuracy</th>
                  <th style={styles.tableHeader}>Progress</th>
                </tr>
              </thead>
              <tbody>
                {chapterWise.map((chapter, index) => (
                  <tr key={index}>
                    <td style={styles.tableCell}>
                      <div style={{ fontWeight: "500" }}>{chapter.chapter}</div>
                      <div style={{ fontSize: "0.85rem", color: "#6c757d" }}>
                        ✓{chapter.correct} ✗{chapter.wrong} ○{chapter.left}
                      </div>
                    </td>
                    <td style={styles.tableCell}>{chapter.total}</td>
                    <td style={styles.tableCell}>
                      <span style={{
                        color: parseInt(chapter.accuracy) > 50 ? "#28a745" : "#dc3545",
                        fontWeight: "600"
                      }}>{chapter.accuracy}</span>
                    </td>
                    <td style={styles.tableCell}>
                      <div style={styles.progressBar}>
                        <div style={{
                          ...styles.progressFill,
                          width: `${(chapter.correct / chapter.total) * 100}%`,
                          backgroundColor: parseInt(chapter.accuracy) > 50 ? "#28a745" : "#dc3545"
                        }}></div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div style={styles.card}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
              <h5 style={{ margin: "0", color: "#2c3e50", fontWeight: "600" }}>Concept Analysis</h5>
              <div style={{ display: "flex", gap: "10px" }}>
                <select style={{
                  padding: "6px 12px",
                  borderRadius: "6px",
                  border: "1px solid #ced4da",
                  backgroundColor: "white",
                  fontSize: "0.9rem"
                }}>
                  <option>Physics</option>
                </select>
                <select style={{
                  padding: "6px 12px",
                  borderRadius: "6px",
                  border: "1px solid #ced4da",
                  backgroundColor: "white",
                  fontSize: "0.9rem"
                }}>
                  <option>Work-energy-power</option>
                </select>
              </div>
            </div>
            <table style={styles.table}>
              <thead>
                <tr>
                  <th style={styles.tableHeader}>Concept</th>
                  <th style={styles.tableHeader}>Accuracy</th>
                  <th style={styles.tableHeader}>Performance</th>
                </tr>
              </thead>
              <tbody>
                {conceptWise.map((concept, index) => (
                  <tr key={index}>
                    <td style={styles.tableCell}>
                      <div style={{ fontWeight: "500" }}>{concept.concept}</div>
                      <div style={{ fontSize: "0.85rem", color: "#6c757d" }}>
                        {concept.total} questions
                      </div>
                    </td>
                    <td style={styles.tableCell}>
                      <span style={{
                        color: parseInt(concept.accuracy) > 70 ? "#28a745" : parseInt(concept.accuracy) > 40 ? "#ffc107" : "#dc3545",
                        fontWeight: "600"
                      }}>{concept.accuracy}</span>
                    </td>
                    <td style={styles.tableCell}>
                      <div style={styles.progressBar}>
                        <div style={{
                          ...styles.progressFill,
                          width: `${(concept.correct / concept.total) * 100}%`,
                          backgroundColor: parseInt(concept.accuracy) > 70 ? "#28a745" : parseInt(concept.accuracy) > 40 ? "#ffc107" : "#dc3545"
                        }}></div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* ================= RIGHT SIDEBAR ================= */}
        <div>
          {/* Subject Accuracy */}
          <div style={styles.card}>
            <h5 style={{ margin: "0 0 20px 0", color: "#2c3e50", fontWeight: "600" }}>Subject Accuracy</h5>
            <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
              {subjectAccuracy.map((subject, index) => (
                <div key={index} style={{ display: "flex", alignItems: "center", gap: "15px" }}>
                  <div style={{
                    width: "50px",
                    height: "50px",
                    borderRadius: "50%",
                    backgroundColor: `${subject.color}20`,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border: `2px solid ${subject.color}`
                  }}>
                    <div style={{ color: subject.color, fontWeight: "700", fontSize: "1.2rem" }}>
                      {subject.value}
                    </div>
                  </div>
                  <div>
                    <div style={{ fontWeight: "600", color: "#2c3e50" }}>{subject.name}</div>
                    <div style={{ fontSize: "0.85rem", color: "#6c757d" }}>
                      {subjectWiseAnalysis[index].correct}/{subjectWiseAnalysis[index].total} correct
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Comparison with Topper */}
          <div style={styles.card}>
            <h5 style={{ margin: "0 0 20px 0", color: "#2c3e50", fontWeight: "600" }}>vs Topper</h5>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "15px" }}>
              <div style={{ textAlign: "center", padding: "15px", backgroundColor: "#e3f2fd", borderRadius: "8px" }}>
                <div style={{ fontSize: "1.1rem", fontWeight: "600", marginBottom: "10px" }}>You</div>
                <div style={{ fontSize: "1.8rem", fontWeight: "700", color: "#2196F3" }}>{comparison.you.score}</div>
                <div style={{ fontSize: "0.9rem", color: "#6c757d" }}>Score</div>
                <div style={{ marginTop: "10px", fontSize: "0.9rem" }}>
                  <div>✓ {comparison.you.correct}</div>
                  <div>✗ {comparison.you.wrong}</div>
                </div>
              </div>
              <div style={{ textAlign: "center", padding: "15px", backgroundColor: "#e8f5e9", borderRadius: "8px" }}>
                <div style={{ fontSize: "1.1rem", fontWeight: "600", marginBottom: "10px" }}>Topper</div>
                <div style={{ fontSize: "1.8rem", fontWeight: "700", color: "#4CAF50" }}>{comparison.topper.score}</div>
                <div style={{ fontSize: "0.9rem", color: "#6c757d" }}>Score</div>
                <div style={{ marginTop: "10px", fontSize: "0.9rem" }}>
                  <div>✓ {comparison.topper.correct}</div>
                  <div>✗ {comparison.topper.wrong}</div>
                </div>
              </div>
            </div>
            <div style={{ marginTop: "15px", textAlign: "center", color: "#6c757d", fontSize: "0.9rem" }}>
              Both have {comparison.you.accuracy} accuracy
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudentData;